module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imgpubl",
    staticStyle: {
      "margin-bottom": "-2.2em"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "1",
      "src": "images/1.jpg"
    }
  })]), _c('p', {
    staticClass: "ctl",
    attrs: {
      "id": "d7e4855"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e4905"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mark_9781595553966_epub_c17_r1#d7e1",
      "id": "d6e1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e4955"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Mark_9781595553966_epub_c19_r1#d7e2",
      "id": "d6e2"
    }
  }, [_c('i', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e5005"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Mark_9781595553966_epub_c20_r1#Anch0005",
      "id": "Anch00115"
    }
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NE")]), _vm._v(": W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISDOM FOR")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUR")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROFESSIONAL")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e5055"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Mark_9781595553966_epub_c21_r1#d7e3",
      "id": "d6e3"
    }
  }, [_vm._v("1. A Matter of Death and Life"), _c('br'), _c('i', [_vm._v("Life Is Brief")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e5145"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mark_9781595553966_epub_c22_r1#d7e4",
      "id": "d6e4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Stay Under the Umbrella"), _c('br'), _c('i', [_vm._v("Finding and Keeping Your Focus in Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e5225"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mark_9781595553966_epub_c23_r1#d7e5",
      "id": "d6e5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Tackle Something So Difficult You’ll"), _c('br'), _vm._v("Never Want to Do It Again"), _c('br'), _c('i', [_vm._v("Getting Out of Your Comfort Zone")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e5335"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mark_9781595553966_epub_c24_r1#d7e6",
      "id": "d6e6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. The Amazing Power of Understatement"), _c('br'), _c('i', [_vm._v("Under-promise, Over-deliver")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e5415"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mark_9781595553966_epub_c25_r1#d7e7",
      "id": "d6e7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Work Less, Think More"), _c('br'), _c('i', [_vm._v("Better Still, Work on Thinking")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e5536"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mark_9781595553966_epub_c26_r1#d7e8",
      "id": "d6e8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Technology Isn’t Everything"), _c('br'), _c('i', [_vm._v("Learning to Use It Wisely")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e5616"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mark_9781595553966_epub_c27_r1#d7e9",
      "id": "d6e9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Buy Some Stamps"), _c('br'), _c('i', [_vm._v("Reclaiming the Lost Art of Letter Writing")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e5696"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mark_9781595553966_epub_c28_r1#d7e10",
      "id": "d6e10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Honesty Can Be Costly"), _c('br'), _c('i', [_vm._v("But Telling the Truth Is Always Good Business")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e5776"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mark_9781595553966_epub_c29_r1#d7e11",
      "id": "d6e11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Money Isn’t Everything; Good People Are"), _c('br'), _c('i', [_vm._v("Creating a Winning Corporate Culture")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e5856"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mark_9781595553966_epub_c30_r1#d7e12",
      "id": "d6e12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Everyone’s in PR"), _c('br'), _c('i', [_vm._v("Are You Practicing It Poorly or Well?")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e5966"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mark_9781595553966_epub_c31_r1#d7e13",
      "id": "d6e13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. And Another Thing . . ."), _c('br'), _c('i', [_vm._v("A Few More Thoughts")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e6066"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mark_9781595553966_epub_c32_r1#Anch0006",
      "id": "Anch001111",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WO")]), _vm._v(": W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISDOM FOR")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUR")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERSONAL")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e6116"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mark_9781595553966_epub_c33_r1#d7e14",
      "id": "d6e14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. God Owns It All"), _c('br'), _c('i', [_vm._v("A Wise Perspective on Things")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e6196"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mark_9781595553966_epub_c34_r1#d7e15",
      "id": "d6e15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. The Wisdom of Firsts"), _c('br'), _c('i', [_vm._v("The First Hour, the First Day, the First Dime")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e6276"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mark_9781595553966_epub_c35_r1#d7e16",
      "id": "d6e16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. A Turtle on a Fence Post"), _c('br'), _c('i', [_vm._v("Appreciating How You Got Where You Are")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e6356"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mark_9781595553966_epub_c36_r1#d7e17",
      "id": "d6e17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. There Are No Degrees of Integrity"), _c('br'), _c('i', [_vm._v("You Either Have It or You Don’t")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e6467"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mark_9781595553966_epub_c37_r1#d7e18",
      "id": "d6e18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. A Proverb a Day"), _c('br'), _c('i', [_vm._v("Wisdom for Every Aspect of Your Life, in One Short Book")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e6597"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mark_9781595553966_epub_c38_r1#d7e19",
      "id": "d6e19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. The Wisdom of Age"), _c('br'), _c('i', [_vm._v("Seek Out Older People")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e6677"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mark_9781595553966_epub_c39_r1#d7e20",
      "id": "d6e20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. Shut Up and Listen"), _c('br'), _c('i', [_vm._v("Learn to Listen More Than You Speak")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e6757"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mark_9781595553966_epub_c40_r1#d7e21",
      "id": "d6e21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. The Best Defense . . . Is a Good Defense"), _c('br'), _c('i', [_vm._v("Why I Won’t Ride Alone with Another Woman")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e6847"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mark_9781595553966_epub_c41_r1#d7e22",
      "id": "d6e22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. Here’s to Not Drinking at All"), _c('br'), _c('i', [_vm._v("Do Wisdom and Alcohol Mix?")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e6947"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mark_9781595553966_epub_c42_r1#d7e23",
      "id": "d6e23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. Anticipate Deathbed Regrets"), _c('br'), _c('i', [_vm._v("Take Steps Now to Avoid Regrets Later in Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e7027"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mark_9781595553966_epub_c43_r1#d7e24",
      "id": "d6e24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. And Another Thing . . ."), _c('br'), _c('i', [_vm._v("A Few More Thoughts")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e7127"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mark_9781595553966_epub_c44_r1#d7e25",
      "id": "d6e25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. The Wisest Decision Anyone Can Make"), _c('br'), _c('i', [_vm._v("Answering the “And then what?” Question")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1a",
    attrs: {
      "id": "d7e7207"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mark_9781595553966_epub_c46_r1#d7e26",
      "id": "d6e26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1a",
    attrs: {
      "id": "d7e7257"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mark_9781595553966_epub_c47_r1#d7e27",
      "id": "d6e27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a0e85608","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mark_9781595553966_epub_c18_r1.vue
// module id = 66
// module chunks = 0